import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader, Divider } from '_template';
import Breadcrumbs from 'components/Breadcrumbs';
import Helmet from 'components/Helmet';
import Actions from './components/Actions';
import CurrencyTable from './components/CurrencyTable';
import LimitedAccess from 'components/LimitedAccess';
import { RIGHTS } from 'constants/rights';

const CurrencyList = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t<string>('CURRENCY.MODEL_TITLE')} />
      <ContentHeader
        title={t('CURRENCY.MODEL_TITLE')}
        actions={<Actions />}
        breadcrumbs={<Breadcrumbs section={t('CURRENCY.MODEL_TITLE')} />}
      />
      <Divider sx={{ my: 4 }} />
      <LimitedAccess right={RIGHTS.CURRENCY.LIST}>
        <CurrencyTable />
      </LimitedAccess>
    </>
  );
};

export default CurrencyList;
